module.exports = __webpack_public_path__ + "img/flag-usa.bae0b885.png";